import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/la-home-exterior.jpg")